<template>
  <div class="bg-white rounded border-0 shadow-sm">
    <div class="d-flex align-items-end p-3">
      <div class="d-flex flex-column">
        <h5 class="mb-1">Splash Message Content</h5>
        <p class="text-gray-500">You can edit the title, description, timout time and variant content the splash message</p>
      </div>
      <ButtonGroup>
        <b-button :class="{'active' : viewMulti === 'preview'}" @click="viewMulti = 'preview'">Preview</b-button>
        <b-button :class="{'active' : viewMulti === 'code'}"  @click="viewMulti = 'code'">Code</b-button>
    </ButtonGroup>
    </div>
      
    <CodePreviewViewer :viewMode="viewMulti" :codeSample="require('./splash_message_contents.js').default">
      <template v-slot:preview>
        <div class="w-100">
          <label class="text-sm mb-1 text-gray-500">Splash Message Title</label>
          <b-form-input v-model="title" class="w-50 mr-2 mb-3"></b-form-input>

          <label class="text-sm mb-1 text-gray-500">Splash Message Description</label>
          <b-form-input v-model="description" class="w-50 mr-2 mb-3"></b-form-input>

          <label class="text-sm mb-1 text-gray-500">Splash Message Time</label>
          <b-form-input v-model="time" placeholder="Splash Message Description" class="mr-2 mb-3" style="width: 10%;"></b-form-input>

          <label class="text-sm mb-1 text-gray-500">Splash Message Variants</label>
          <b-form-group label="Splash Message Variants">
            <b-form-radio-group
              v-model="variant"
              :options="variants"
              name="radio-inline"
            ></b-form-radio-group>
          </b-form-group>
          
          <b-button variant="primary" @click="openSplashMessage()">Open Splash Message</b-button>
          <SplashMessage ref='splashMessage'/>
        </div>
      </template>
    </CodePreviewViewer>
  </div>
</template>

<script>
import SplashMessage from '@/components/export/SplashMessage/SplashMessage'
import ButtonGroup from '@/components/export/ButtonGroup/ButtonGroup'
import CodePreviewViewer from '@/components/local/CodePreviewViewer'

export default {
  components: { SplashMessage, ButtonGroup, CodePreviewViewer },
  data () {
    return {
      viewMulti: 'preview',
      title: null,
      description: null,
      variant: 'primary',
      time: 5000,
      variants: [
        'primary',
        'success',
        'warning',
        'danger'
      ]
    }
  },
  methods: {
    openSplashMessage () {
      this.$refs.splashMessage.show({
        title: this.title,
        description: this.description,
        variant: this.variant,
        time: this.time
      })
    }
  }
}
</script>